<template>
    <spinner-container :loading="loading">
      <v-container fluid>
        <v-row>
          <v-col
            lg="3"
            md="4"
            sm="6"
            v-for="item in townships"
            v-bind:key="item.id"
          >
            <v-card class="card--shadow" height="150" @click="linkTo(item.id)">
              <v-card-text>
                <h1 class="header_text">{{ item.short_code }}</h1>
                <h3>{{ item.name }}</h3>
              </v-card-text>
            </v-card>
          </v-col>
  
        </v-row>
        
      </v-container>
    </spinner-container>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import SpinnerContainer from "../container/SpinnerContainer.vue";
  export default {
    components: { SpinnerContainer },
    props: {
      toRoute: {
        type: String,
      },
    },
    created() {
      this.$store.dispatch("Township/getTownships");
    },
    computed: {
      ...mapState("Township", ["townships"]),
      ...mapState("Loading", ["loading"]),
    },
    methods: {
      linkTo(id) {
        this.$router.replace({
         name:this.toRoute,
          params:{
            township_id:id
          }
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    display: flex;
    align-items: center;
    text-align: center;
    border-radius: 20px;
  }
  
  .header_text {
    color: var(--primary-color);
    margin-bottom: 10px;
  }
  </style>
  